


























































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import moment from 'moment';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { delay, difference, uniq, without } from "lodash";
import IOutboundDeliveryNoteProduct from '@/store/models/IOutboundDeliveryNoteProduct';
import IWarehouse from '@/store/models/IWarehouse';

@Component({
    components: {
        FilterMenu
    }
})
export default class OutboundDeliveryNoteDetailCustomerStockSelector extends Vue {
  menu2: boolean = false;
  searchOutboundDetailCustomerStock: string = '';
  dialog: boolean = false;
  isValid: boolean = true;
  sortBy: string = 'goodName';
  sortDesc: boolean = false;
  headers: any = [
      { text: 'Good', align: 'start', value: 'goodName' },
      { text: 'Good Code', value: 'goodCode' },
      { text: 'Inb. Number Source', value: 'codeInbounds' },
      { text: 'Inb. Number Destination', value: 'codeDestination' },
      { text: 'Pallet type', value: 'listPalletName' },
      { text: 'Pallet Id', value: 'idPallet' },
      { text: 'Location', value: 'location' },
      { text: 'Total cases', value: 'totalCases' },
      { text: 'Goods per case', value: 'goodsPerCase' },
      { text: 'Weight per pallet (Kg)', value: 'weight' },
      { text: 'BBDate', value: 'bestBeforeDate' },
      { text: 'Ref. Inb. Number', value: 'referenceInboundCode' },
      { text: 'Language', value: 'language' },
      { text: 'Douana Document', value: 'documentation' },
      { text: 'Actions', value: 'actions', sortable: false }
  ];
  editedIndex: number = -1;
  editedItem: IStock = {
      id: '',
      idOutboundDetail: '',
      codeOutbound: '',
      idOutboundDeliveryNoteDetail: '',
      idInboundDeliveryNoteDetail: '',
      codeInbounds: '',
      idMovementDetail: '',
      idNoticeOfLossDetail: '',
      idCompanySource: '',
      companySourceName: '',
      idCompanyDestination: '',
      companyDestination: '',
      idWarehouse: '',
      warehouseName: '',
      idCustomer: '',
      customerName: '',
      idGood: '',
      goodName: '',
      idListPallet: '',
      listPalletName: '',
      idPallet: '',
      palletsAmount: 0,
      casesPerPallet: 0,
      totalCases: 0,
      goodsPerCase: 0,
      totalGoods: 0,
      dateIn: new Date(),
      dateOut: new Date(),
      location: '',
      bestBeforeDate: new Date(),
      isSelected: false,
      referenceInboundCode: '',
      language: '',
      documentation: false,
      allocatedCases: 0,
      allocatedGoods: 0,
      availableCasesFinal: 0,
      availableGoodsFinal: 0,
      idInbound: '',
      sellCases: 0,
      sellGoods: 0,
      availablePalletsAmountFinal: 0,
      totalGoodsSell: 0,
      palletsAmountSell: 0,
      isTransformed: '',
      codeDestination: '',
      weight: 0,
      idPalletCustomer: '',
      goodCode: '',
      sku: ''
  };
  defaultItem: IStock = {
      id: '',
      idOutboundDetail: '',
      codeOutbound: '',
      idOutboundDeliveryNoteDetail: '',
      idInboundDeliveryNoteDetail: '',
      codeInbounds: '',
      idMovementDetail: '',
      idNoticeOfLossDetail: '',
      idCompanySource: '',
      companySourceName: '',
      idCompanyDestination: '',
      companyDestination: '',
      idWarehouse: '',
      warehouseName: '',
      idCustomer: '',
      customerName: '',
      idGood: '',
      goodName: '',
      idListPallet: '',
      listPalletName: '',
      idPallet: '',
      palletsAmount: 0,
      casesPerPallet: 0,
      totalCases: 0,
      goodsPerCase: 0,
      totalGoods: 0,
      dateIn: new Date(),
      dateOut: new Date(),
      location: '',
      bestBeforeDate: new Date(),
      isSelected: false,
      referenceInboundCode: '',
      language: '',
      documentation: false,
      allocatedCases: 0,
      allocatedGoods: 0,
      availableCasesFinal: 0,
      availableGoodsFinal: 0,
      idInbound: '',
      sellCases: 0,
      sellGoods: 0,
      availablePalletsAmountFinal: 0,
      totalGoodsSell: 0,
      palletsAmountSell: 0,
      isTransformed: '',
      codeDestination: '',
      weight: 0,
      idPalletCustomer: '',
      goodCode: '',
      sku: ''
  };

  goodNamesFilter: string[] = [];
  goodCodeFilter: string[] = [];
  inboundCodeFilter: string[] = [];
  inboundCodeDestinationFilter: string[] = [];
  locationsFilter: string[] = [];
  bestBeforeDatesFilter: Date[] = [];

  @Prop({ type: Array, required: true })
  CustomerStockDeliveryNoteDetail!: IStock[];
  @Prop({ type: Array, required: true })
  Permissions!: IRolePermission[];
  @Prop()
  SelectedWarehouse!: IWarehouse;
  @Prop({ type: Array, required: true })
  OutboundDeliveryNoteProductSelected!: IOutboundDeliveryNoteProduct[];
  @Prop({ type: Boolean, default: false })
  ScannerActive!: boolean;
  @Prop()
  value!: IStock[];

  selectedStockCustomerToDelivery: IStock[] = [];
  selectedCustomerStockDetail: IStock[] = [];
  bestBeforeDate: string = new Date().toISOString().substr(0, 10);

  async mounted() {
      // 👉 Si el escáner está activo, cambiar cabecera de Language → Merken nummer
      if (this.ScannerActive) {
          const idx = this.headers.findIndex(
              (h: { text: string; value: string }) => h.value === 'language'
          );
          if (idx !== -1) {
              this.headers[idx].text = 'Merken nummer';
              this.headers[idx].value = 'idPalletCustomer';
          }
      }
  }

  get goodCodes(): string[] {
      return uniq(
          this.CustomerStockDeliveryNoteDetail
          .filter(b => b.goodCode !== null && b.goodCode !== "")
          .map(b => b.goodCode)
      );
  }

  get formTitle() {
      return this.editedIndex === -1 ? 'Add customer stock' : 'Edit customer stock';
  }

  get TotalCases() {
      return this.selectedStockCustomerToDelivery.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
  }

  get MaxCases(): number {
      return this.OutboundDeliveryNoteProductSelected.length > 0
          ? this.OutboundDeliveryNoteProductSelected[0].totalCases
          : 0;
  }
  get displayedTotalWeightSelected(): string {
      return Number(this.TotalWeightSelected || 0).toFixed(2);
  }
  get TotalWeightSelected(): number {
      return this.selectedStockCustomerToDelivery.reduce(
          (sum, current) => sum + (current.weight || 0),
          0
      );
  }

  get IsOverLimit(): boolean {
      return this.TotalCases > this.MaxCases;
  }

  get displayedTotalCases() {
      return this.TotalCases;
  }

  @Watch('value')
  updateSelection(newValue: IStock[] | null) {
      if (!newValue || Object.keys(newValue).length === 0) {
          this.selectedStockCustomerToDelivery = [];
      }
  }

  @Watch('selectedStockCustomerToDelivery')
  onChangeselectedStockCustomerToDelivery() {
      if (this.selectedStockCustomerToDelivery.length > 0) {
          this.$emit('input', this.selectedStockCustomerToDelivery);
      } else {
          this.$emit('input', null);
      }
  }

  ToDateFormat(date: string): string {
      if (date === '' || date === null) {
          return '';
      }
      return moment(new Date(date)).format('DD-MM-YYYY');
  }

  getFilteredCustomerStock(): IStock[] {
      if (this.CustomerStockDeliveryNoteDetail.length > 0) {
          return this.CustomerStockDeliveryNoteDetail.filter((i) => i.totalCases > 0);
      }
      return [];
  }

  get goodNames(): string[] {
      return uniq(
          this.CustomerStockDeliveryNoteDetail.filter((b) => b.goodName !== null).map((b) => b.goodName)
      );
  }

  get inboundCodes(): string[] {
      return uniq(
          this.CustomerStockDeliveryNoteDetail.filter((b) => b.codeInbounds !== null).map((b) => b.codeInbounds)
      );
  }

  get inboundCodeDestinations(): string[] {
      return uniq(
          this.CustomerStockDeliveryNoteDetail.filter((b) => b.codeDestination !== null).map((b) => b.codeDestination)
      );
  }

  get locations(): string[] {
      return uniq(
          this.CustomerStockDeliveryNoteDetail.filter((b) => b.location !== null).map((b) => b.location)
      );
  }

  get bestBeforeDates(): Date[] {
      return uniq(
          this.CustomerStockDeliveryNoteDetail.filter((b) => b.bestBeforeDate !== null).map((b) => b.bestBeforeDate)
      );
  }

  editOutboundCustomerStock(item: any, dbox = true) {
      if (this.selectedStockCustomerToDelivery.length > 0) {
          this.editedIndex = this.CustomerStockDeliveryNoteDetail.indexOf(item);
          if (this.editedItem.documentation === null) {
              this.editedItem.documentation = false;
          }
          this.editedItem = Object.assign({}, item);
          this.dialog = true;
      }
  }

  saveDeliveryNoteDetailCustomerStock() {
      let index = this.CustomerStockDeliveryNoteDetail.findIndex(
          (i) => i.idPallet === this.editedItem.idPallet && i.idInboundDeliveryNoteDetail === this.editedItem.idInboundDeliveryNoteDetail
      );
      Object.assign(this.CustomerStockDeliveryNoteDetail[index], this.editedItem);
      this.close();
  }

  generateGUID(): string {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
      });
  }

  get stockItemsFiltered(): IStock[] {
      let filteredList: IStock[] = this.CustomerStockDeliveryNoteDetail
      .filter((s) => s.totalCases > 0)
      .filter((s) => s.goodName === this.OutboundDeliveryNoteProductSelected[0].goodName)
      .filter((s) => s.codeInbounds === this.OutboundDeliveryNoteProductSelected[0].inboundCode);
      // ✅ Nuevo filtro por peso
      if (this.OutboundDeliveryNoteProductSelected[0].totalWeight) {
          filteredList = filteredList.filter(
              (s) => s.weight === this.OutboundDeliveryNoteProductSelected[0].totalWeight
          );
      }

      if (this.inboundCodeFilter.length > 0) {
          filteredList = filteredList.filter((b) => this.inboundCodeFilter.includes(b.codeInbounds));
      }
      if (this.goodNamesFilter.length > 0) {
          filteredList = filteredList.filter((b) => this.goodNamesFilter.includes(b.goodName));
      }
      if (this.locationsFilter.length > 0) {
          filteredList = filteredList.filter((b) => this.locationsFilter.includes(b.location));
      }
      if (this.bestBeforeDatesFilter.length > 0) {
          filteredList = filteredList.filter((b) => this.bestBeforeDatesFilter.includes(b.bestBeforeDate));
      }
      if (this.SelectedWarehouse.name !== '') {
          filteredList = filteredList.filter((b) => this.SelectedWarehouse.id === b.idWarehouse);
      }
      if (this.inboundCodeDestinationFilter.length > 0) {
          filteredList = filteredList.filter((b) => this.inboundCodeDestinationFilter.includes(b.codeDestination));
      }
      if (this.goodCodeFilter.length > 0) {
          filteredList = filteredList.filter((b) => this.goodCodeFilter.includes(b.goodCode));
      }
      // Asignar un GUID a cada elemento de la lista filtrada
      filteredList.forEach((item) => {
          if (!item.id) {
              item.id = this.generateGUID();
          }
      });

      return filteredList;
  }

  close(): void {
      this.dialog = false;
      this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
      });
  }
}
